/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Room_TeamInputs */

const en_of_room_team = /** @type {(inputs: Of_Room_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team area`)
};

const id_of_room_team = /** @type {(inputs: Of_Room_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area tim`)
};

/**
* | output |
* | --- |
* | "Team area" |
*
* @param {Of_Room_TeamInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_room_team = /** @type {((inputs?: Of_Room_TeamInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Room_TeamInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_room_team(inputs)
	return en_of_room_team(inputs)
});